import React, { useEffect, useMemo, useState } from 'react';
import { Popover, Button, Select } from 'antd';
import { DownOutlined, UpOutlined, CloseOutlined } from '@ant-design/icons';
import 'antd/dist/reset.css';

const { Option } = Select;
const allFields = [
  { label: 'Task Name', value: 'taskName', type: 'text' },
  { label: 'Project Manager', value: 'projectManager', type: 'text' },
  { label: 'Assignee', value: 'assignee', type: 'text' },
  { label: 'Time Tracking', value: 'timeTracking', type: 'number' },
  { label: 'Priority', value: 'priority', type: 'priority' },
  { label: 'Time Estimate', value: 'timeEstimate', type: 'number' },
  { label: 'Task Flow', value: 'taskFlow', type: 'text' },
  { label: 'Status', value: 'status', type: 'text' },
  { label: 'Pipeline', value: 'pipeline', type: 'text' },
  { label: 'Description', value: 'description', type: 'text' },
  { label: 'Sequence No.', value: 'sequenceNo', type: 'number' },
  { label: 'Start Date', value: 'startDate', type: 'date' },
  { label: 'End Date', value: 'endDate', type: 'date' },
  { label: 'Created On', value: 'createdOn', type: 'date' },
  { label: 'SLA', value: 'TaskStatusDate', type: 'number' },
];

function SortManager({ sortFilters, setSortFilters }) {
  const [sortCriteria, setSortCriteria] = useState([{ field: '', order: 'asc' }]);
  const [isOpen, setIsOpen] = useState(false);

  const addSortField = () => {
    setSortCriteria([...sortCriteria, { field: '', order: 'asc' }]);
  };

  const updateSortField = (index, key, value) => {
    const newCriteria = [...sortCriteria];
    newCriteria[index][key] = value;
    setSortCriteria(newCriteria);
  };

  const removeSortField = (index) => {
    if (sortCriteria.length === 1){
       setSortCriteria([{ field: '', order: 'asc' }]);
       return;
    }
    const newCriteria = [...sortCriteria];
    newCriteria.splice(index, 1);
    setSortCriteria(newCriteria);
  };
  const disableAdd = useMemo(() => sortCriteria.some((criteria) => !criteria.field), [sortCriteria]);

   const onApply = (criteria) => {
    if((sortCriteria.length == 1 && sortCriteria[0].field == "" ? false : disableAdd)) return;
      setSortFilters(criteria.length == 1 && criteria[0].field == "" ? [] : criteria);
      setIsOpen(false);
    }

  const availableFields = (currentField) =>
    allFields.filter(
      (field) =>
        !sortCriteria.some(
          (criteria) =>
            criteria.field === field.value && criteria.field !== currentField
        )
    );

  const getOrderLabels = (fieldValue) => {
    const field = allFields.find((f) => f.value === fieldValue);
    if (!field) return { asc: 'A → Z', desc: 'Z → A' };
    return field.type === 'number' ? { asc: '1 → 9', desc: '9 → 1' } : field.type =="priority" ? 
    { asc: 'Low → High', desc: 'High → Low' } : { asc: 'A → Z', desc: 'Z → A' };
  };


  const popoverContent = (
    <div className="sort-popover">
        <div className="sort-container">
      {sortCriteria.map((criteria, index) => {
        const orderLabels = getOrderLabels(criteria.field);

        return (
          <div key={index} className="sort-row">
            <Select
              showSearch
              placeholder="Find a field"
              value={criteria.field}
              rootClassName="field-select"
              style={{ height: 'auto' }}
              onChange={(value) =>
                updateSortField(index, 'field', value)
              }
              filterOption={(input, option) =>
                option.children.toLowerCase().includes(input.toLowerCase())
              }
            >
              {availableFields(criteria.field).map((field) => (
                <Option key={field.value} value={field.value}>
                  {field.label}
                </Option>
              ))}
            </Select>

            <div className="order-toggle">
              <button
                className={`toggle-button ${
                  criteria.order === 'asc' ? 'active' : ''
                }`}
                style={{borderRadius : criteria.order === 'asc' ? '20px' : '20px 0 0 20px'}}
                onClick={() => updateSortField(index, 'order', 'asc')}
              >
                {orderLabels.asc}
              </button> 
              <button
                className={`toggle-button ${
                  criteria.order === 'desc' ? 'active' : ''
                }`}
                style={{borderRadius : criteria.order === 'desc' ? '20px' : '0 20px 20px 0'}}
                onClick={() => updateSortField(index, 'order', 'desc')}
              >
                {orderLabels.desc}
              </button>
            </div>

            <button
              className="remove-button"
              onClick={() => removeSortField(index)}
            >
              <CloseOutlined />
            </button>
          </div>
        );
      })}
      </div>
    <div className='buttons-container-sort-manager'>
      <Button
        className={`${disableAdd ? 'disabled' : ''}`}
        onClick={addSortField}
        disabled={disableAdd || sortCriteria.length == allFields.length}
      >
        + Add Sort
      </Button>
      <Button
        className={`apply-button ${disableAdd ? 'disabled' : ''}`}
        onClick={() => onApply(sortCriteria)}
        disabled={(sortCriteria.length == 1 && sortCriteria[0].field == "" ? false : disableAdd)}
        >
        Apply
      </Button>
          </div>
    </div>
  );

  return (
    <Popover
      content={popoverContent}
      trigger="click"
      open={isOpen}
      placement="bottomLeft"
      styles={{ root: { width: "auto", height: "auto" } }}
      rootClassName='custom-popover-for-sort-manager'
      onOpenChange = {()=>{
        setSortCriteria(sortFilters.length > 0 ? sortFilters : [{ field: '', order: 'asc' }])
        setIsOpen(!isOpen);
      }}
    >
      <Button className="sort-button" onClick={() => {
        setSortCriteria(sortFilters.length > 0 ? sortFilters : [{ field: '', order: 'asc' }])
        setIsOpen(!isOpen)
      }}>
        ⇅ Sort {sortFilters.length > 0 && <span className="count-badge">{sortFilters.length}</span>}
      </Button>
    </Popover>
  );
}

export default SortManager;
